import { render } from "./ShippingList.vue?vue&type=template&id=71e9c7c9&scoped=true"
import script from "./ShippingList.vue?vue&type=script&lang=js"
export * from "./ShippingList.vue?vue&type=script&lang=js"

import "./ShippingList.vue?vue&type=style&index=0&id=71e9c7c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e9c7c9"]])

export default __exports__